"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusCode = void 0;
var StatusCode;
(function (StatusCode) {
    StatusCode["OK"] = "OK";
    StatusCode["GRAPHQL_FAILURE"] = "GRAPHQL_FAILURE";
    StatusCode["SERVER_FAILURE"] = "SERVER_FAILURE";
    StatusCode["OTHER_FAILURE"] = "OTHER_FAILURE";
})(StatusCode = exports.StatusCode || (exports.StatusCode = {}));
